type GroupByMeta = { [name: string]: any };

type GroupByResult<T> = {
    root: T;
    children: T[];
    meta: GroupByMeta;
}[];

/**
 * Group array into chunks, using callback function
 *
 * @param source - input array
 * @param cb - should return a metadata object - this will split the data into next chunk; return null if data doesnt need to split
 */
export const groupBy = <T>(source: T[], cb: (a: T, b: T) => GroupByMeta | null): GroupByResult<T> => {
    return source.reduce((groups: GroupByResult<T>, currentValue) => {
        const lastGroup = groups[groups.length - 1];

        const newWrapperObject = (root: T, meta = {}) => ({ root, children: [root], meta });

        if (!lastGroup) {
            return [...groups, newWrapperObject(currentValue)];
        }

        const lastValue = lastGroup.children[lastGroup.children.length - 1];

        const belongsToGroup = cb(lastValue, currentValue);

        if (belongsToGroup) {
            return [...groups, newWrapperObject(currentValue, belongsToGroup)];
        }

        lastGroup.children.push(currentValue);
        return groups;
    }, []);
};
